import React from "react";
import Logo from "../assets/img/Logo2.jpg"; // นำเข้ารูปภาพ

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 footer-contact">
              <img
                src={Logo}  // ใช้ตัวแปร IMGlogo ที่นำเข้า
                alt="Logo"
                className="footer-logo"
                style={{
                  width: "100px", // ขนาดของโลโก้
                  marginBottom: "10px", // ระยะห่างระหว่างโลโก้และข้อความ
                }}
              />
              <h3>CDCOT</h3>
              <p>
                <strong>Phone:</strong> 02-579-0583, 02-940-5484-5<br />
                <strong>Email:</strong> thaicoconut.org@gmail.com
              </p>
            </div>

            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                {[
                  { name: "Home", id: "hero" },
                  { name: "About us", id: "about" },
                  { name: "News", id: "news" },
                  { name: "Gallery", id: "portfolio" },
                  { name: "Documents", id: "documents" }
                ].map((link, index) => (
                  <li key={index}>
                    <i className="bx bx-chevron-right"></i>
                    <a href={`#${link.id}`}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>


            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Alliance</h4>
              <ul>
                {[
                  { name: "Tropicana Oil", url: "https://tropicanaoil.com/" },
                  { name: "Chiwadi", url: "https://chiwadi.com/" },
                  { name: "AgriLife", url: "https://agrilife.co.th/" },
                  { name: "Thai Coconut", url: "https://thaicoconut.com/" },
                  { name: "สถาบันวิจัยพืชสวน", url: "https://www.doa.go.th/hort/" }
                ].map((service, index) => (
                  <li key={index}>
                    <i className="bx bx-chevron-right"></i>
                    <a href={service.url} target="_blank" rel="noopener noreferrer">{service.name}</a>
                  </li>
                ))}
              </ul>
            </div>


            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Our future social media platforms</h4>
              <p>Stay connected with us through our upcoming social media platforms, where we’ll share updates, news, and exciting content about our journey</p>
              <div className="social-links mt-3">
                {[
                  { name: "twitter", url: "https://twitter.com/" },
                  { name: "facebook", url: "https://www.facebook.com/profile.php?id=100064619806537" },
                  { name: "instagram", url: "https://www.instagram.com/" },
                  { name: "google-plus", url: "mailto:thaicoconut.org@gmail.com" },
                  { name: "linkedin", url: "https://www.linkedin.com/" }
                ].map((network, index) => (
                  <a
                    key={index}
                    href={network.url}
                    className={network.name}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className={`bx bxl-${network.name}`}></i>
                  </a>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="container py-2">
        <div className="copyright">
          &copy; Copyright <strong><span>Thaicoconut.org</span></strong>. All Rights Reserved
        </div>
        <div className="credits">
          Designed by <a href="https://bootstrapmade.com/">Thaicoconut</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
